import './Document.scss';
import { Button } from 'components/InteractiveUIControls/Button/Button';
import { Svgicon } from 'components/Svgicon/Svgicon';
import {
  type FC,
  type SyntheticEvent,
} from 'react';
import { isMobile } from 'services/mobile';
import {
  type DocumentDTO,
} from 'types';
import { COLORS } from 'types/Colors';

type DocumentComponentProps = DocumentDTO & {
  documentOnClick:
  (event: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLElement>)
  => Promise<void>,
  downloadClick:
  (event: SyntheticEvent | undefined) => Promise<void>,
  fileByIdLoading: boolean,
  groupName: string,
  period: number | string,
};

export const RecentDocument: FC<DocumentComponentProps> = ({
  accountName,
  documentOnClick,
  downloadClick,
  fileByIdLoading,
  fileType,
  fundName,
  groupName,
  period,
  userViewed,
  version,
}) => {
  const mobile = isMobile();

  const mainFileContent = `${groupName} ${version ? `#${version}` : ''}`;

  const renderDownloadButtonOnHover = () =>
    <div className='show-on-hover'>
      <Button
        className='!h-6 !w-[1.325rem]'
        data-test='download-file'
        icon='only'
        iconid='download-arrow'
        isLoading={fileByIdLoading}
        onClick={(event) => downloadClick(event)}
        size='medium'
        squared
        tooltipWrapperClass='!w-auto'
      />
    </div>;

  return (
    <div
      className='recent-documents-container relative flex h-auto w-full min-w-[10.875rem] max-w-[90rem] rounded-full border border-black-200 bg-white-999 p-[0.75rem] ms:min-w-[16.875rem]'
      data-test={`resent-document-${period}`}
      onClick={documentOnClick}
      role='button'
      tabIndex={0}
    >
      <div className='recent-document-content flex flex-col items-start gap-[0.5rem]'>
        <div className='flex items-center gap-[0.5rem]'>
          {!mobile && renderDownloadButtonOnHover()}
          <Svgicon className='hide-on-hover relative size-6' dataTest={userViewed ? 'document-viewed' : 'document-new'} id={userViewed ? 'seen-recent-document' : 'new-recent-document'} text={fileType.slice(0, 3)} />
          <div className='flex flex-col gap-[0.375rem]'>
            <div className='max-w-[8.5rem] ms:max-w-60'>
              <p className={`${userViewed && '!font-normal'} mb-0 truncate text-font-2 font-semibold text-black-999`}>{mainFileContent}</p>
              <p className={`${userViewed && '!font-normal'} mb-0 truncate text-font-2 font-semibold text-black-999`}>
                {period}
              </p>
            </div>
          </div>
        </div>
        <div className='flex flex-col gap-[0.25rem]'>
          <div className='flex gap-[0.25rem]'>
            <Svgicon className='size-[0.75rem]' color={COLORS['$black-600']} id='luggage-04' />
            <div className='max-w-40 ms:max-w-52'>
              <p className='acc-or-fund-name m-0 truncate text-font-3 font-normal text-black-600'>
                {fundName}
              </p>
            </div>

          </div>
          <div className='flex gap-[0.25rem]'>
            <Svgicon className='size-[0.75rem]' color={COLORS['$black-700']} id='user-profile-2f' />
            <div className='max-w-40 ms:max-w-52'>
              <p className='acc-or-fund-name m-0 truncate text-font-3 font-normal text-black-600'>
                {accountName}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
